module.exports = __webpack_public_path__ + "fcfa23cabcea06c6386e69bcbb809cab.jpg";